<template>
  <PuSkeletonTheme :duration="0.1" class="" :color="skeletonColor" :highlight="skeletonHighlight">
    <div v-for="index in 3" :key="index">
      <vx-card class="mb-4">
        <div class="vx-row ">
          <div class="vx-col w-1/5">
            <PuSkeleton class="responsive rounded" style="width: 100%; height: 100%;">
            </PuSkeleton>
          </div>
          <div class="vx-col w-2/5">
            <div class="my-1">
              <PuSkeleton class="block w-full" style="width: 100%; height: 24px;">
              </PuSkeleton>
            </div>
            <div class="my-1">
              <PuSkeleton class="block w-full" style="width: 100%; height: 24px;">
              </PuSkeleton>
            </div>
            <div class="my-1">
              <PuSkeleton class="block w-full" style="width: 100%; height: 24px;">
              </PuSkeleton>
            </div>
          </div>
          <div class="vx-col w-2/5 items-center align-middle ">
            <div class="my-1">
              <PuSkeleton class="block w-full" style="width: 100%; height: 38px;">
              </PuSkeleton>
            </div>
            <div class="my-1">
              <PuSkeleton class="block w-full" style="width: 100%; height: 38px;">
              </PuSkeleton>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </PuSkeletonTheme>
</template>

<script>
export default {
  computed: {
    skeletonColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(224, 224, 224)'
      if (theme === 'midnight') return 'rgb(6,0,73)'
      if (theme === 'dark') return 'rgb(27, 30, 34)'
    },
    skeletonHighlight () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(248, 248, 248)'
      if (theme === 'midnight') return 'rgb(27 25 53)'
      if (theme === 'dark') return 'rgb(94 94 94 / 73%)'
    }
  }
}
</script>

<style scoped>

</style>
